import {
  AirportData,
  AlternativeRouteComponent,
  Stopover,
  TransportType,
} from "@/core/types/types";

const getFullAlternativeRoute = (
  altTransportOrigin: AirportData,
  altTransportDestination: AirportData,
  transportationMode: string,
  stopoverData: Stopover[] = []
): AlternativeRouteComponent[] => {
  const components: AlternativeRouteComponent[] = [];

  let currentDeparture = altTransportOrigin;

  stopoverData?.forEach((stopover: Stopover) => {
    components.push(<AlternativeRouteComponent>{
      departure: currentDeparture,
      arrival: { ...stopover },
      transportationMode: transportationMode ?? TransportType.plane,
    });

    currentDeparture = { ...stopover };
    transportationMode = stopover.mode;
  });

  components.push(<AlternativeRouteComponent>{
    departure: currentDeparture,
    arrival: altTransportDestination,
    transportationMode: transportationMode ?? TransportType.plane,
  });

  return components;
};

export default getFullAlternativeRoute;
